







































import { DataError } from '@/app/components';
import { S } from '@/app/utilities';
import { InformationCircleIcon, XCircleIcon } from '@vue-hero-icons/solid';
import { computed, defineComponent, PropType } from '@vue/composition-api';
import { SelfBuildingSquareSpinner } from 'epic-spinners';
import { isNil } from 'ramda';

export default defineComponent({
    name: 'ColumnMetricsCard',
    props: {
        name: { type: String, default: '' },
        type: { type: String, default: '' },
        metrics: { type: Array, default: () => [] },
        loading: { type: Boolean, default: false },
        errorResponse: {
            type: Object as PropType<{ message?: string; status: number }>,
            required: false,
        },
    },
    components: { SelfBuildingSquareSpinner, DataError, InformationCircleIcon },
    setup(props: any) {
        const hasDividerLine = (index: number) => Math.floor(index / 2) !== Math.floor((props.metrics.length - 1) / 2);

        const error = computed(() => {
            if (!props.errorResponse) return null;

            return {
                message: 'Unable to load metrics for this column',
                tooltip: props.errorResponse.message,
                icon: XCircleIcon,
                classes: 'text-danger-700',
            };
        });

        return { isNil, error, hasDividerLine, S };
    },
});
